import axios from "axios";
import apiConfig from "../config/api.js";

const API_URL = apiConfig.baseURL;

// Fonction helper pour obtenir le token
const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Service pour gérer les badges et niveaux de cuisinier
 */

const badgeService = {
  /**
   * Récupérer tous les badges disponibles
   * @returns {Promise} Liste de tous les badges
   */
  getAllBadges: async () => {
    try {
      const response = await axios.get(`${API_URL}/badges`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des badges:", error);
      throw error.response?.data || error;
    }
  },

  /**
   * Récupérer les badges d'un utilisateur
   * @param {number} userId - ID de l'utilisateur
   * @returns {Promise} Liste des badges de l'utilisateur
   */
  getUserBadges: async (userId) => {
    try {
      const response = await axios.get(`${API_URL}/badges/user/${userId}`);
      return response.data;
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des badges de l'utilisateur:",
        error
      );
      throw error.response?.data || error;
    }
  },

  /**
   * Vérifier et attribuer automatiquement les badges
   * @returns {Promise} Nouveaux badges gagnés
   */
  checkBadges: async () => {
    try {
      const response = await axios.post(
        `${API_URL}/badges/check`,
        {},
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la vérification des badges:", error);
      throw error.response?.data || error;
    }
  },

  /**
   * Obtenir les statistiques des badges d'un utilisateur
   * @param {number} userId - ID de l'utilisateur
   * @returns {Promise} Statistiques
   */
  getUserBadgeStats: async (userId) => {
    try {
      const response = await axios.get(
        `${API_URL}/badges/user/${userId}/stats`
      );
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des statistiques:", error);
      throw error.response?.data || error;
    }
  },

  /**
   * Obtenir les prochains badges à débloquer
   * @returns {Promise} Liste des prochains badges
   */
  getNextBadges: async () => {
    try {
      const response = await axios.get(`${API_URL}/badges/next`, {
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des prochains badges:",
        error
      );
      throw error.response?.data || error;
    }
  },

  /**
   * Obtenir le classement des utilisateurs par badges
   * @param {number} limit - Limite de résultats
   * @returns {Promise} Classement
   */
  getTopUsersByBadges: async (limit = 10) => {
    try {
      const response = await axios.get(`${API_URL}/badges/leaderboard`, {
        params: { limit },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération du classement:", error);
      throw error.response?.data || error;
    }
  },

  /**
   * Obtenir les badges groupés par catégorie
   * @returns {Promise} Badges groupés
   */
  getBadgesByCategory: async () => {
    try {
      const response = await axios.get(`${API_URL}/badges/categories`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des badges:", error);
      throw error.response?.data || error;
    }
  },
};

export default badgeService;
